import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ColumnComponent } from '../column.component';
import { BadgeAsset } from 'src/app/models/image/dto/badge-asset';
import { SectionColumnProductInfoType } from 'src/app/models/enum/shared/section-column-product-info-type';

@Component({
  selector: 'app-column-strain-type',
  templateUrl: './column-strain-type.component.html',
  styleUrls: ['./column-strain-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ColumnStrainTypeComponent extends ColumnComponent {
  @Input() useNgContent: boolean;

  getNonListColumnItem(): BadgeAsset | string | undefined {
    if (this.colVm.columnConfigDataValueIsBadgeMode()) {
      return this.rowVm.getBadgeAssetForColumnType(SectionColumnProductInfoType.StrainType)?.image;
    }
    return this.rowVm.getReadableStrainType(this.colVm.strainTypeMode);
  }
}
